module.exports = __webpack_public_path__ + "img/live-fzky.36ed8d28.png";